// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"1a4bec78","72":"b779b881","168":"f88d44d1","470":"c4942b46","558":"80f0b881","627":"a339470a","712":"c6a29742"}[chunkId] + ".chunk.css";
};